import React, { useState, useEffect } from 'react';
import { LottieWrapper } from './index';
import Error from '../assets/suspend/error.json';
import '../components/styles/ackBg.css';
import withDashboardMenuLayout from './layout/withDashboardMenuLayout';

const CommonTechnicalIssue = () => {
  const redirectToHome = () => {
    window.location.href = `${window.location.origin}/SignUp`;
  };

  useEffect(() => {
    // DOCS: Clearing the state on encryption error
    // console.log('[INFO] Error in encryptTransform redux store: ', error);
    // FIXME: For local testing, No need to clear the state
    if (window.location.hostname !== 'localhost') {
      console.log('[INFO] Cleaning Old State ...');
      localStorage.clear();
    }
  }, []);

  return (
    <>
      <div className={`h-screen lg:!h-[85vh] mobile:w-full `}>
        <div className="absolute p-6 bottom-4 flex flex-col">
          <LottieWrapper animationData={Error} width="250px" height="250px" />
          <span className="mt-5 font-headline font-bold text-[28px]">
            There is some technical issue
          </span>
          <span className="font-headline mt-3 font-semibold text-base text-text-secondary">
            Something went wrong, Please try again later
          </span>
          <button
            type="button"
            onClick={redirectToHome}
            className="w-[350px] mobile:w-full py-3 bg-accent text-white rounded-md shadow-lg font-headline mt-4 font-semibold text-base"
          >
            Okay, got it
          </button>
        </div>
      </div>
    </>
  );
};

export default CommonTechnicalIssue;
